import { render, staticRenderFns } from "./GroupTic.vue?vue&type=template&id=7867a050"
import script from "./GroupTic.vue?vue&type=script&lang=js"
export * from "./GroupTic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports